import useConfirmDiscardChanges from './useConfirmDiscardChanges';
import useConfirmSaveLegalDocument from './useConfirmSaveLegalDocument';

export { useConfirmDiscardChanges, useConfirmSaveLegalDocument };
